module.exports = __webpack_public_path__ + "static/media/inquiry_history.0ceb3650.svg";